import mixpanel from 'mixpanel-browser';

const DEBUG_MODE = process.env.NODE_ENV === 'development';
const TRACK_PAGEVIEW = true;
const PERSISTENCE = 'localStorage';
const RECORD_SESSIONS_PERCENT = 50; // Record 50% of user sessions for Session Replay (reduces data usage while maintaining insights)
const RECORD_HEATMAP_DATA = true;   // Enable Heatmap data collection for click and scroll tracking
const RECORD_MASK_TEXT_SELECTOR = ''; //unmask all text elements
const RECORD_MAX_MS = 300000; // Maximum session recording duration: 5 minutes
const RECORD_MIN_MS = 8000; // Minimum session recording duration: 8 seconds (filters out very brief visits)

class MixpanelService {
  constructor() {
    this.isInitialized = false;
    this.mixpanel = mixpanel;
  }

  init(token) {
    if (this.isInitialized) {
      return;
    }

    if (!token) {
      console.warn('Mixpanel token is required');
      return;
    }

    this.mixpanel.init(token, {
      debug: DEBUG_MODE,
      track_pageview: TRACK_PAGEVIEW,
      persistence: PERSISTENCE,
      record_sessions_percent: RECORD_SESSIONS_PERCENT,
      record_heatmap_data: RECORD_HEATMAP_DATA,
      record_mask_text_selector: RECORD_MASK_TEXT_SELECTOR,
      record_max_ms: RECORD_MAX_MS,
      record_min_ms: RECORD_MIN_MS,
    });

    this.isInitialized = true;
  }

  identify(userId) {
    if (!this.isInitialized) {
      return;
    }

    this.mixpanel.identify(userId);
  }

  setUserProperties(properties) {
    if (!this.isInitialized) {
      return;
    }

    this.mixpanel.people.set(properties);
  }

  getInstance() {
    return this.mixpanel;
  }
}

const mixpanelService = new MixpanelService();

export default mixpanelService;
